import styles from "../../styles/shared/RequestLiveSuggestionModal.module.css";
import { PiChartLineUpBold } from "react-icons/pi";
import { TfiPieChart } from "react-icons/tfi";
import { TbListCheck } from "react-icons/tb";

function SuggestionTabs({ activeTab, setActiveTab }) {
  const changeTab = (tab) => () => setActiveTab(tab);

  return (
    <div className={styles.tabs}>
      <span
        className={`${styles.tabItem} ${activeTab === "analysis" ? styles.active : ""}`}
        onClick={changeTab("analysis")}
      >
        {/*<MdFlashOn size={16} />*/}
        <PiChartLineUpBold size={16} />
        Live Analysis
      </span>
      <span
        className={`${styles.tabItem} ${activeTab === "chart" ? styles.active : ""}`}
        onClick={changeTab("chart")}
      >
        {/*<FaChartLine />*/}
        <TfiPieChart size={16} />
        Backtest Chart
      </span>
      <span
        className={`${styles.tabItem} ${activeTab === "history" ? styles.active : ""}`}
        onClick={changeTab("history")}
      >
        {/*<MdOutlineHistory size={17} />*/}
        <TbListCheck size={17} />
        Backtest History
      </span>
    </div>
  );
}

export default SuggestionTabs;
